import React, { useEffect, useState, useContext, useMemo } from "react";

import StickyBox from "react-sticky-box";
import { User1 } from "../../imagepath";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useParams } from "react-router-dom";
import { publisherDetail } from "../../../services/publisherService";
import { AppContext } from "../../../services/AuthContext";
import { buildPublisherPath, extractIdFromSlug } from "../../../utils/slugify";
import { getFilePath } from "../../../services/axiosInstance";

export default function InstructorSidebar({ publisher: publisherProp }) {
  const location = useLocation();

  const params = useParams();
  const { auth } = useContext(AppContext);

  // resolve id: prefer explicit /:id, otherwise extract from /:slug
  const id = useMemo(() => {
    if (params.id) return Number(params.id);
    if (params.slug) {
      const raw = extractIdFromSlug(params.slug);
      return raw && /^\d+$/.test(raw) ? Number(raw) : null;
    }
    return null;
  }, [params.id, params.slug]);

  const [publisherLocal, setPublisherLocal] = useState(null);
  const profileData = publisherProp || publisherLocal;

  const getProfile = async () => {
    if (!id) return;
    try {
      const data = await publisherDetail(id, 1, auth?.token);
      if (data && data.status === "OK") {
        setPublisherLocal(data.data);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setPublisherLocal(null);
    }
  };

  useEffect(() => {
    let alive = true;
    if (!publisherProp && id) {
      (async () => {
        try {
          const data = await publisherDetail(id, 1, auth?.token);
          if (!alive) return;
          if (data && data.status === "OK") setPublisherLocal(data.data);
        } catch (e) {
          // ignore
        }
      })();
    }
    return () => { alive = false; };
  }, [id, publisherProp, auth?.token]);

  if (!profileData) {
    return <p>Loading...</p>;
  }

  // build paths
  const pubsPath = id ? `/publisher/publications/${id}` : "";
  const authorsPath = id ? `/publisher/authors/${id}` : "";

  const publisherSlugPath = profileData && id
    ? buildPublisherPath({ title: profileData.title, id })
    : (id ? `/publisher-detail/${id}` : "");

  const infoActive = location.pathname === publisherSlugPath || (id && location.pathname === `/publisher-detail/${id}`);

  return (
    <div className="col-xl-3 col-lg-3 theiaStickySidebar">
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className="settings-widget dash-profile">
          <div className="settings-menu">
            <div className="profile-bg">
              <div className="profile-img">
                <Link to={publisherSlugPath || "#"}>
                  <img
                    crossOrigin="anonymous"
                    src={profileData.photo
                      ? getFilePath(`publishers/displayFile/${profileData.id}/${profileData.photo}`)
                      : User1}
                    alt={profileData.title || "Publisher"} />
                </Link>
              </div>
            </div>
            <div className="profile-group">
              <div className="profile-name text-center">
                <h4>
                  <Link to={publisherSlugPath || "#"}>{`${profileData.title}`}</Link>
                </h4>

              </div>
            </div>
          </div>
        </div>
        <div className="settings-widget account-settings">
          <div className="settings-menu">
            <ul>
              <li className={`nav-item ${infoActive ? 'active' : ''}`}>
                <Link to={publisherSlugPath || `/publisher-detail/${id}`} className="nav-link">
                  <i className="bx bxs-user" />
                  Yayıncı Bilgileri
                </Link>
              </li>

              <li className={`nav-item ${location.pathname === pubsPath ? 'active' : ''}`}>
                <Link to={pubsPath} className="nav-link">
                  <i className="bx bxs-star" />
                  Yayınlar
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === authorsPath ? 'active' : ''}`}>
                <Link to={authorsPath} className="nav-link">
                  <i className="bx bxs-cart" />
                  Yazarlar
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === '/instructor/instructor-quiz' || location.pathname === '/instructor/instructor-quiz-details' ? 'active' : ''}`}>
                <Link  className="nav-link">
                  <i className="bx bxs-shapes" />
                  Atıflar
                </Link>
              </li>
             
           
            </ul>
       
         
          </div>
        </div>
      </StickyBox>
    </div>
  );
}
